<template>
    <div class="mydrawer">
        <el-drawer :visible.sync="drawer" size="90%" :with-header="false" :wrapper-closable="false" direction="btt">
            <div class="checkBox">
                <!-- 分类项 -->
                <div class="kind-action">
                    <div>频道分类</div>
                    <div class="tags"> 
                        <div :class="['tag', currentIndexOne == 0 ? 'active' : '']" @click="clickOne(0,-1)">全部</div>
                        <div :class="['tag',currentIndexOne == index + 1 ? 'active' : '']" v-for="(item,index) in groupOne" @click="clickOne(item.value,index)" :key="index">{{ item.name }}</div>
                    </div>
                </div>

                <div class="kind-action">
                    <div>小说分类</div>
                    <div class="tags"> 
                        <div :class="['tag', currentIndexTwo == 0 ? 'active' : '']" @click="clickTwo(0,-1)">全部</div>
                        <div :class="['tag',currentIndexTwo == index + 1 ? 'active' : '']" v-for="(item,index) in groupTwo" @click="clickTwo(item.value,index)" :key="index">{{ item.name }}</div>
                    </div>
                </div>

                <div class="kind-action">
                    <div>时间分类</div>
                    <div class="tags"> 
                        <div :class="['tag', currentIndexThere == 0 ? 'active' : '']" @click="clickThere(0,-1)">全部</div>
                        <div :class="['tag',currentIndexThere == index + 1 ? 'active' : '']" v-for="(item,index) in groupThere" @click="clickThere(item.value,index)" :key="index">{{ item.name }}</div>
                    </div>
                </div>
                
                <div class="btn-box">
                    <el-button type="info" @click="reset">重置</el-button>
                    <el-button type="success" @click="comfirm">确认</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
  
<script>
export default {
    name: 'myDrawer.vue',
    props: {
        drawer: {
            type: Boolean,
            default: true
        },
        groupOne:{
            type:Array,
            default(){
                return []
            }
        },
        groupThere:{
            type:Array,
            default(){
                return []
            }
        },
        groupTwo:{
            type:Array,
            default(){
                return []
            }
        }
    },
    data() {
        return {
            currentIndexOne:0,
            currentIndexTwo:0,
            currentIndexThere:0,
            currentValue:[0,0,0]
        }
    },
    methods: {
        clickOne(item,index){
            this.currentIndexOne = index + 1
            this.currentValue[0] = item
        },
        clickTwo(item,index){
            this.currentIndexTwo = index + 1
            this.currentValue[1] = item
        },
        clickThere(item,index){
            this.currentIndexThere = index + 1
            this.currentValue[2] = item
        },
        reset(){
            this.currentIndexOne = 0
            this.currentIndexTwo = 0
            this.currentIndexThere = 0
            this.currentValue = [0,0,0]
        },
        comfirm(){
            this.$emit('comfirm',this.currentValue)
        }
    }
}
</script>
  
<style scoped lang="scss">
.mydrawer {
    width: 100%;
    ::v-deep .el-drawer__open .el-drawer.btt {
        width: 100%;
        padding: 40px 15px 20px;
    }
    
    .checkBox {
        width: 100%;
        height: 100%;
        position: relative;
        .kind-action {
            margin-bottom: 20px;
            .tags {
                .tag {
                    border-radius: 6px;
                    color: rgba(0,0,0,.4);
                    display: inline-block;
                    flex: none;
                    font-size: 13px;
                    line-height: 18px;
                    padding: 2px 10px;
                    margin-top: 12px;
                    margin-right: 6px;
                }
                .active {
                    background: rgba(0,0,0,.06);
                    color: #000;
                }
                
            }
        }
        .btn-box {
            position: absolute;
            width: 100%;
            bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
  